const LoadPlacesScript = (callback) => {
  const existingScript = document.getElementById('googlePlaces');
  if (!existingScript) {
    const script = document.createElement('script');
    const options = {
      types: ['(cities)'],
      componentRestrictions: { country: 'in' },
    };
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDCF-b1N89za5IiNd95L27vx-XyFzUeoCE&libraries=places&types=(cities)&callback=Function.prototype';
    script.id = 'googlePlaces';
    document.head.appendChild(script);
    script.onload = () => {
      // if (callback) callback();
    };
  }
  // if (existingScript && callback) callback();
};
export default LoadPlacesScript;
